import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Person } from '../../core/model/central/person.model';
import { Pet } from '../appointments/state/appointment.model';

@Component({
    selector: 'pets-detail',
    templateUrl: './pets-detail.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PetsDetailComponent {
    @Input() selectedPatient: Person;

    getPetBirthday(pet: Pet): string {
      if (pet.monthOfBirth.toString().length === 2) {
        return `${pet.yearOfBirth}-${pet.monthOfBirth}-${pet.dayOfBirth}`;
      }

      return `${pet.yearOfBirth}-0${pet.monthOfBirth}-${pet.dayOfBirth}`;
    }

    isValidDate(pet: Pet): boolean {
      const isInvalidWhen = pet.dayOfBirth === 0 ||
                            pet.monthOfBirth === 0 ||
                            pet.yearOfBirth === 0;

      return !isInvalidWhen;
    }
}
